
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/status-api/view",
      function () {
        return require("private-next-pages/status-api/view.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/status-api/view"])
      });
    }
  